class PurchaseOrderDirectiveController extends BaseController
	autoScopeInject: false

	@register angular.module 'App.Module.Controller'
	@inject '$scope',
		'$filter'
		'MessageTerminal'
		'MessageTypes'
		'PurchaseOrderFormatService'
		'ConfigurationService'
		'PurchaseOrderShippingCostService'
		'PURCHASE_ORDER'

	initialize: ->
		@showAsReport ?= true
		@isLocked ?= false
		@completionFieldsAreLocked ?= true
		@productsList = null
		@priceRegionId = null
		@totalShippingCost = 0

		@isCostPriceRecalculationEnabled = @ConfigurationService.isEnabled(
			'Backoffice.Setting.RecalculateCostPriceOnPurchaseOrder.Enabled'
		)

		@filter =
			stockLocationId: null
			shopId: null
			supplierId: null
			startTime: moment().subtract(2, 'week').unix()
			endTime: moment().add(2, 'days').endOf('day').unix()
			sort:
				property: 'product_name'
				direction: 'ASC'

		if not _.isEmpty @purchaseOrder
			@productsList = @PurchaseOrderFormatService.purchaseOrderToReport @purchaseOrder
			@calculatePurchaseOrderTotals()

			@priceRegionId = @purchaseOrder.price_region_id

			@$scope.$watch 'purchaseOrderDirective.productsList',
				=> do @onProductsListChange,
				true

			@filter = angular.extend(
				@filter,
				{
					stockLocationId: @purchaseOrder.stock_location_id
					shopId: @purchaseOrder.shop_id
					supplierId: @purchaseOrder.supplier_id
					startTime: moment().unix(@purchaseOrder.expected_delivery_time)
					endTime: moment().unix(@purchaseOrder.expected_delivery_time)
				}
			)

	calculatePurchaseOrderTotals: ->
		@totals =
			costPrice: 0
			productQuantity: 0
			productVariantQuantity: 0

		for productGroup in @productsList
			for product in productGroup
				if product.virtual
					continue

				quantity = @getProductQuantity(product)
				costPrice = parseInt(product.cost_price ? product.actual_cost_price ? 0)

				if product.product_variant_id?
					@totals.productVariantQuantity += quantity
				else
					@totals.productQuantity += quantity

				@totals.costPrice += quantity * costPrice

	onProductsListChange: ->
		for products in @productsList
			for product in products
				if product.virtual
					continue

				existingProduct = _.find(
					@purchaseOrder.line_items,
					{
						product_id: product.product_id
						product_variant_id: product.product_variant_id
					}
				)

				if existingProduct?
					existingProduct = angular.extend existingProduct, product

					continue

				@purchaseOrder.line_items.push product

		if @purchaseOrder.shipping_cost > 0
			unitShippingCost = @calculateUnitShippingCost(@purchaseOrder.shipping_cost)
			@adjustProductCosts(unitShippingCost)

		@calculatePurchaseOrderTotals()

		# `removeProduct()` sets `dirty` on the backing line item directly (bypassing ng-model),
		# and does so *before* splicing the row out of `productsList`, so by the time this deep
		# watch fires, the removed row no longer exists in `productsList` to inspect. Check
		# `purchaseOrder.line_items` instead, since the backing item's `dirty` flag survives there.
		hasDirtyChanges = _.some @purchaseOrder.line_items, {dirty: true}

		@$scope.$parent.mainCrud.parent_form.$setDirty() if hasDirtyChanges

	applyShippingCost: ->
		unitShippingCost = @calculateUnitShippingCost(@totalShippingCost)
		@adjustProductCosts(unitShippingCost)

		@purchaseOrder.shipping_cost = @totalShippingCost
		@totalShippingCost = 0

	getTotalProductsQuantity: ->
		totalQuantity = 0

		for productGroup in @productsList
			totalQuantity += @getGroupQuantity(productGroup)

		return totalQuantity

	getGroupQuantity: (productGroup) ->
		groupQuantity = 0

		for product in productGroup
			groupQuantity += @getProductQuantity(product)

		return groupQuantity

	getProductQuantity: (product) ->
		if product.virtual || !product.selected
			return 0

		receivedQuantity = parseFloat(product.received_quantity)

		if receivedQuantity > 0
				return receivedQuantity

		return parseFloat(product.requested_quantity ? 0)

	adjustProductCosts: (unitShippingCost) ->
		for productGroup in @productsList
			for product in productGroup
				if product.virtual
					continue

				product.dirty = true
				product.cost_price ?= product.actual_cost_price ? 0
				product.cost_price -= product.shipping_cost
				product.shipping_cost = if @getProductQuantity(product) > 0 then unitShippingCost else 0
				product.cost_price += product.shipping_cost

	resetProductCosts: ->
		@purchaseOrder.shipping_cost = 0
		isDirty = false

		for productGroup in @productsList
			for product in productGroup
				if product.virtual
					continue

				product.dirty = true
				product.cost_price ?= product.actual_cost_price ? 0
				product.cost_price -= product.shipping_cost
				isDirty ||= parseInt(product.shipping_cost) > 0
				product.shipping_cost = 0

		if isDirty
			@$scope.$parent.mainCrud.parent_form.$setDirty()

	calculateUnitShippingCost: (totalShippingCost) ->
		totalQuantity = @getTotalProductsQuantity()

		return @PurchaseOrderShippingCostService.calculateUnitShippingCost(totalShippingCost, totalQuantity)
